$.tinysort.defaults.cases = false;  

// gets current read only status on thepage level
var ReadOnlyFlag = false;

// global variable holds the php file name to check moving data between 
var CheckWith_FileName = '';

function access()
{
	var hash = window.location.hash;
	hash = hash.replace("#", "");
	var access = $('#sort_right li').length;
	var array = new Array();
	var data_array = new Array();

	if ((hash == "user_access") || (hash == "sort_access"))
	{
		$('#sort_right li').each(function(index)
		{
			array.push($(this).attr('class').split(' ')[0]);
		});

		var i = 0;
		var access = access - 1;

		for (i = 0; i <= access; ++i)
		{
			data_array.push($('#sort_right .' + array[i]).attr('class').split(' ')[0]);
			data_array.push($('#sort_right .' + array[i] + ' .access').val());
		}
	}
	return data_array;
}

 // reads the list right or left and returns string of id.aceess name
function GetListData(lkupList)
{
	var hash = window.location.hash;
	hash = hash.replace("#", "");
	var access = $('#' + lkupList + ' li').length;
	var array = new Array();
	var data_array = new Array();
	var i = 0;
	var access = access - 1;
	var t =''
	
	// read all ids from list
	$('#sort_right li').each(function(index)
	{
		array.push($(this).attr('class').split(' ')[0]);
	});
	 // check if there are access or sort options 
	if (((hash == "user_access") || (hash == "sort_access")) && lkupList == 'sort_right' )
	{
		for (i = 0; i <= access; ++i)
		{
			// check if its read only item 
			t= $('#' + lkupList + ' .' + array[i]).attr('class').split(' ')[0];   
			if (t.substring(0,2) == 'RO' )
			{
				data_array.push(array[i] + '.' + $('#' + lkupList + ' .' + array[i] + ' .user_select').text());
			}
			else
			{
				data_array.push(array[i] + '.' + $('#' + lkupList + ' .' + array[i] + ' .access').find(":selected").text());
			}					
		}
		return data_array;
	}
	else
	{
		return array;
	}	
}

function updateAddList()
{
	var $add = $("#add");

	$add.html("");

	$("#sort_right").children().each(function()
	{
		var $this = $(this);
		var id = $this.find(".popuptext").attr('class').split(' ')[1];
		// do updates only for not read only items  
		if  (!($this.attr('RoFlag') == "1" || ReadOnlyFlag == "true") )
		{ 			
			var $access = $this.find(".access");
			if ($add.html().trim().length)
			{
				if ($access.length)
				{  
					$add.html($add.html() + "," + id + "," + $access.val());
					
				}
				else
				{  
					$add.html($add.html() + "," + id);
				}
			}
			else
			{
				if ($access.length)
				{   
					$add.html(id + "," + $access.val());
				}
				else
				{  
					$add.html(id);
				}
			}
		}
	});
}

(function($)
{
	$.fn.drag_drop_selectable = function(options)
	{
		$.fn.captureKeys();
		var $_this = this;
		var settings = $.extend({}, $.fn.drag_drop_selectable.defaults, options || {});
		updateAddList(); // init the add array with pre-populated selections

		$('#sortup').on("click", function()
		{
			var prev = $('#sort_right .dds_selected').prev().html();
			var prevID=$('#sort_right .dds_selected').prev().find(":selected").index();
			var currentID=$('#sort_right .dds_selected').find(":selected").index();
			if(prev != null)
			{
				$('#sort_right .dds_selected').prev().html($('#sort_right .dds_selected').html());
				// Need to exchange the height settings as well: hieght of each list item can be different
				var prevHeight = $('#sort_right .dds_selected').prev().css('height');
				$('#sort_right .dds_selected').prev().css('height',$('#sort_right .dds_selected').css('height'));
				$('#sort_right .dds_selected').css('height',prevHeight);
				if(currentID)
				{
					$('#sort_right .dds_selected').prev().find('.access').prop('selectedIndex', currentID);	
				} 
				$('#sort_right .dds_selected').html(prev);              
				if(prevID)
				{
					$('#sort_right .dds_selected .access').prop('selectedIndex', prevID);
				}           
				$('#sort_right .dds_selected').prev().addClass('dds_selected'); 
				$('#sort_right .dds_selected:eq(1)').removeClass('dds_selected');
				var sort_order = new Array();
				$("#sort_right .sort_list").each(function()
				{
					var $this = $(this);
					if($this.find(".popuptext").attr('class').split(' ')[1])
					{
						sort_order.push($this.find(".popuptext").attr('class').split(' ')[1]);	
					}             
							
					if($this.find(":selected").val())
					{
						sort_order.push($this.find(":selected").val()); 	
					} 
				});
				var sorting = sort_order.join();
				$("#add").empty();
				$("#add").html(sorting);
				
				// call this to check if in Healthcare/Admin/ Admin Settings section
				// and then set the tab to show modified style
				UpdateHealthCareTab();
			}
		})

		$('#sortdo').on("click", function()
		{
			var next = $('#sort_right .dds_selected').next().html();
			var nextID = $('#sort_right .dds_selected').next().find(":selected").index();
			var currentID = $('#sort_right .dds_selected').find(":selected").index();

			if (next != null)
			{
				$('#sort_right .dds_selected').next().html($('#sort_right .dds_selected').html());
				// Need to exchange the height settings as well: hieght of each list item can be different
				var nextHeight = $('#sort_right .dds_selected').next().css('height');
				$('#sort_right .dds_selected').next().css('height',$('#sort_right .dds_selected').css('height'));
				$('#sort_right .dds_selected').css('height',nextHeight);
				if (currentID)
				{
					$('#sort_right .dds_selected').next().find('.access').prop('selectedIndex', currentID);
				}

				$('#sort_right .dds_selected').html(next);

				if (nextID)
				{
					$('#sort_right .dds_selected .access').prop('selectedIndex', nextID);
				}

				$('#sort_right .dds_selected').next().addClass('dds_selected');
				$('#sort_right .dds_selected:eq(0)').removeClass('dds_selected');

				var sort_order = new Array();
				$("#sort_right .sort_list").each(function()
				{
					var popupText = $(this).find(".popuptext");
					if (popupText.attr('class').split(' ')[1])
					{
						sort_order.push(popupText.attr('class').split(' ')[1]);
					}
					var selected = $(this).find(":selected");
					if (selected.val())
					{
						sort_order.push(selected.val());
					}
				});
				var sorting = sort_order.join();
				$("#add").empty();
				$("#add").html(sorting);
				
				// call this to check if in Healthcare/Admin/ Admin Settings section
				// and then set the tab to show modified style
				UpdateHealthCareTab();
			}
		})

		var $body = $("body");
		var rulerSpan = document.getElementById('ruler');

		$("#popup").hide();

		// Each column (2 feeds)
		return $(this).each(function(i)
		{
			var $list = $(this);
			var list_id = $.fn.drag_drop_selectable.unique++;
			$.fn.drag_drop_selectable.stack[list_id] = [];
			$list.attr('dds', list_id);

			$.fn.drag_drop_selectable.settings[list_id] = settings;

			// Each item (user)
			$list.find('li').each(function()
			{
				var $item = $(this);

				var popupText = $item.find('.popuptext');

				// ruler is an invisible span element in the dragndrop.html
				// It was added to read the actual - visual pixel width of a string
				// 220 px is the maximum string width that list box can fit in one line
				// The following will check the current string width, and, if necessary, add extra height to accomodate string wrap.
				rulerSpan.innerHTML = popupText.html();
				if (rulerSpan.offsetWidth >= 220)
				{
					var height = Math.ceil(rulerSpan.offsetWidth / 220);
					var hpx = height * 16 + 'px';
					$item.css('height', hpx);
				}

				// add item to list!
				var item_id = $.fn.drag_drop_selectable.unique++;
				$item.attr('dds', item_id);
				$.fn.drag_drop_selectable.stack[list_id].push(item_id);

				// check for the read only item and read only page level , disable this item and do not attach events on it
				if  ($item.attr('RoFlag') == "1" || ReadOnlyFlag == "true") 
				{
					$body.css("cursor", 'default');					
					return 0;
				}
				else
				{
					$item.on('click.dds_select', function(e)
					{
						var $this = $(this);
						if ($.fn.isPressed(CTRL_KEY))
						{
							// ctrl pressed add to selection
							$.fn.drag_drop_selectable.toggle($this);
						}
						else
						{
							// Make new selection
							$.fn.drag_drop_selectable.replace($this);
						}
						e.preventDefault();
						return false;
					}).on('dds.select', function(e)
					{
						var $this = $(this);
						if ($this.hasClass('left_icon') == true)
						{
							$this.removeClass('left_icon');
							$this.addClass('had_icon');
						}

						if ($this.hasClass('right_icon') == true)
						{
							$this.removeClass('right_icon');
							$this.addClass('had_icn');
						}

						$this.addClass('dds_selected').addClass($.fn.drag_drop_selectable.settings[$.fn.drag_drop_selectable.getListId($this.attr('dds'))].selectClass);
						e.preventDefault();
						return false;
					}).on('dds.deselect', function(e)
					{
						var $this = $(this);
						$this.removeClass('dds_selected');
						if ($this.hasClass('had_icn') == true)
						{
							$this.removeClass('had_icn');
							$this.addClass('right_icon');
						}

						if ($this.hasClass('had_icon') == true)
						{
							$this.removeClass('had_icon');
							$this.addClass('left_icon');
						}
						e.preventDefault();
						return false;
					}).css(
					{
						cursor : 'pointer'
					});
				}	
			})
			// OK so they are selectable. now I need to make them draggable, in such a way that they pick up their friends when dragged. hmmm how do I do that?
			.draggable(
			{
				helper : function()
				{
					$clicked = $(this);
					if (!$clicked.hasClass('dds_selected'))
					{
						// trigger the click function.
						$clicked.trigger('click.dds_select');
					}
					var listId = $.fn.drag_drop_selectable.getListId($clicked.attr('dds'));
					var $helper = $('<div dds_list="' + listId + '"><div style="margin-top:-' + $.fn.drag_drop_selectable.getMarginForDragging($clicked) + 'px;" /></div>').append($.fn.drag_drop_selectable.getSelectedForDragging($clicked.attr('dds')));
					$.fn.drag_drop_selectable.getListFromId(listId).filter('.dds_selected').addClass($.fn.drag_drop_selectable.settings[listId].ghostClass);
					// Also add width from selected item to draggable
					// will fix issue on IE 8 when dragging item's width is not set correctly
					var SelectedItemWidth = $.fn.drag_drop_selectable.getListFromId(listId).filter('.dds_selected').css('width');
					$helper.css("width",SelectedItemWidth);
					return $helper;
				},
				distance : 5, // give bit of leeway to allow selecting with click.
				revert : 'invalid',
				cursor : 'move',
				stop : function(e, ui)
				{
					var listId = $.fn.drag_drop_selectable.getListId($clicked.attr('dds'));
					$.fn.drag_drop_selectable.getListFromId(listId).filter('.dds_selected').removeClass($.fn.drag_drop_selectable.settings[listId].ghostClass);
				}
			});
			$list.droppable(
			{
				drop : function(e, ui)
				{
					var oldlist = parseInt(ui.helper.attr('dds_list'));
					ui.helper.find('li.dds_selected').each(function()
					{
						var $this = $(this);
						var iid = parseInt($this.attr('dds_drag'));
						var database_id = $this.attr('class').split(' ')[0];
						$.fn.drag_drop_selectable.moveBetweenLists(iid, oldlist, list_id, database_id);
					});

					// now call callbacks!
					if ($.fn.drag_drop_selectable.settings[oldlist] && (typeof ($.fn.drag_drop_selectable.settings[oldlist].onListChange) == 'function'))
					{
						setTimeout(function()
						{
							$.fn.drag_drop_selectable.settings[oldlist].onListChange($('ul[dds=' + oldlist + ']'));
							updateAddList();
						}, 50);
					}
					if ($.fn.drag_drop_selectable.settings[list_id] && (typeof ($.fn.drag_drop_selectable.settings[list_id].onListChange) == 'function'))
					{
						setTimeout(function()
						{
							$.fn.drag_drop_selectable.settings[list_id].onListChange($('ul[dds=' + list_id + ']'));
							updateAddList();
						}, 50);
					}
				},
				accept : function(d)
				{
					if ($.fn.drag_drop_selectable.getListId(d.attr('dds')) == $(this).attr('dds'))
					{
						return false;
					}
					return true;
				},
				hoverClass : $.fn.drag_drop_selectable.settings[list_id].hoverClass,
				tolerance : 'pointer'
			});
		});
	};

	function sort_alpha()
	{
		var list = [];
		$(".left").each(function()
		{
			list.push($(this).text())
		});

		list.sort();

		$(".left").each(function(index, value)
		{
			$(this).text(list[index]);
		});
	}

	var add = new Array();
	var minus = new Array();
	var total_access = new Array();

	add = access();
	$.fn.drag_drop_selectable.moveBetweenLists = function(item_id, old_list_id, new_list_id, database_id)
	{
		var Parms = [];
		Parms.itemId = item_id;
		Parms.oldListId = old_list_id;
		Parms.newListId = new_list_id;
		Parms.databaseId = database_id;

		//send request to confirm this action
		var AssignFlag = old_list_id ? 0:1;	 // asign =1 unassign=0

		DoSendRequest_ToMove (database_id, AssignFlag, Parms);	
	};

	MoveItem = function(Status, Parms)
	{
		// Status == true if is ok to make a move 	
		if (Status != true)
			return;

		var item_id = Parms.itemId;
		var old_list_id = Parms.oldListId;
		var new_list_id = Parms.newListId;
		var database_id = Parms.databaseId;

		var left_column = $('ul[dds=' + old_list_id + ']').find('li[dds=' + item_id + ']').attr('class').split(' ')[1];
		// check for the read only item and read only page level , disable this item and do not attach events on it
		var RoFlag = $('ul[dds='+old_list_id+']').find('li[dds='+item_id+']').attr('RoFlag');

		if (RoFlag != '1' && ReadOnlyFlag != "true")
		{
			if (new_list_id && (left_column == 'left'))
			{
				add.push(database_id);
			}
			else if ((new_list_id != old_list_id) && (left_column == 'left'))
			{
				var i = 0;
				for (i = 0; i < add.length; i++)
				{
					if (add[i] == database_id)
					{
						add.splice(i, 1);
					}
				}
			}

			if (old_list_id && (left_column == 'right'))
			{
				minus.push(database_id);

			}
			else if ((old_list_id != new_list_id) && (left_column == 'right'))
			{
				var n = 0;
				for (n = 0; n < minus.length; n++)
				{
					if (minus[n] == database_id)
					{
						minus.splice(n, 1);
					}
				}
			}

			var hash = window.location.hash;
			hash = hash.replace("#", "");

			var asb_add = add.toString();
			var asb_minus = minus.toString();
			var array_length = add.length;
			var i = 0;

			$('#remove').html(asb_minus);
			var $item = $('li[dds=' + item_id + ']');
			$.fn.drag_drop_selectable.deselectItem($item);
			$.fn.drag_drop_selectable.stack[old_list_id].splice($.inArray(parseInt(item_id), $.fn.drag_drop_selectable.stack[old_list_id]), 1);
			$.fn.drag_drop_selectable.stack[new_list_id].push(parseInt(item_id));

			var mode;
			if (hash == "user_access")
			{
				mode = "user_access";
			}
			else if (hash == "sort_access")
			{
				mode = "sort_access";
			}
			else
			{
				mode = "user";
			}

			if ((mode == "user_access") || (mode == "sort_access"))
			{
				if (left_column == 'left')
				{
					$('ul[dds=' + old_list_id + ']').find('li[dds=' + item_id + ']').addClass(database_id + ' left ').removeClass($.fn.drag_drop_selectable.settings[old_list_id].ghostClass).appendTo($('ul[dds=' + new_list_id + ']'));
					$('#sort_right .user_left').show();
					$('#sort .user_left').hide();
					$('#sort_right').find('.user_select').show();

					if (($('.' + database_id).hasClass('left') == true) && ($('.' + database_id).hasClass('left_icon') == false))
					{
						$('.' + database_id).addClass('left_icon');
					}

				}
				else if (left_column == 'right')
				{
					$('ul[dds=' + old_list_id + ']').find('li[dds=' + item_id + ']').addClass(database_id + ' right user_right').removeClass($.fn.drag_drop_selectable.settings[old_list_id].ghostClass).appendTo($('ul[dds=' + new_list_id + ']'));
					$('#sort').find('.user_select').hide();

					if ($('ul[dds=' + old_list_id + ']').find('.user_right').length > 0)
					{
						$('#sort_right').find('.user_select').show();
					}

					if (($('.' + database_id).hasClass('right') == true) && ($('.' + database_id).hasClass('right_icon') == false))
					{
						$('.' + database_id).addClass('right_icon');
					}
				}
			}
			else
			{
				if (left_column == 'left')
				{
					$('ul[dds=' + old_list_id + ']').find('li[dds=' + item_id + ']').addClass(database_id + ' left').removeClass($.fn.drag_drop_selectable.settings[old_list_id].ghostClass).appendTo($('ul[dds=' + new_list_id + ']'));

					if (($('.' + database_id).hasClass('left') == true) && ($('.' + database_id).hasClass('left_icon') == false))
					{
						$('.' + database_id).addClass('left_icon');
					}

				}
				else if (left_column == 'right')
				{
					$('ul[dds=' + old_list_id + ']').find('li[dds=' + item_id + ']').addClass(database_id + ' right').removeClass($.fn.drag_drop_selectable.settings[old_list_id].ghostClass).appendTo($('ul[dds=' + new_list_id + ']'));

					if (($('.' + database_id).hasClass('right') == true) && ($('.' + database_id).hasClass('right_icon') == false))
					{
						$('.' + database_id).addClass('right_icon');
					}
				}
			}

			$('ul#sort>li').removeClass('left_icon');
			$('ul#sort_right>li').removeClass('right_icon');
			$("#sort_right .access").parent().show();
			
			// call this to check if in Healthcare/Admin/ Admin Settings section
			// and then set the tab to show modified style
			UpdateHealthCareTab();

			updateAddList();
		}		
	};

	$.fn.drag_drop_selectable.getSelectedForDragging = function(item_id)
	{
		var listId = $.fn.drag_drop_selectable.getListId(item_id);
		var $others = $.fn.drag_drop_selectable.getListFromId(listId).clone().each(function()
		{
			var $this = $(this);
			$this.not('.dds_selected').css(
			{
				visibility : 'hidden'
			});
			$this.filter('.dds_selected').addClass($.fn.drag_drop_selectable.settings[listId].moveClass).css(
			{
				opacity : $.fn.drag_drop_selectable.settings[listId].moveOpacity
			});
			$this.attr('dds_drag', $this.attr('dds'));
			$this.attr('dds', '');
		});
		return $others;
	};

	$.fn.drag_drop_selectable.getMarginForDragging = function($item)
	{
		// find this items offset and the first items offset.
		var this_offset = $item.position().top;
		// list items can be set to not visible when there is a search performed
		// so to make sure the first item offset reads coordinates of the first item in the list that is visible 
		var first_offset = $item.parent('ul').children('li').filter(':visible').eq(0).position().top;
		return this_offset - first_offset;
	}

	$.fn.drag_drop_selectable.toggle = function($item)
	{
		if (!$.fn.drag_drop_selectable.isItemSelected($item))
		{
			$.fn.drag_drop_selectable.selectItem($item);
		}
		else
		{
			$.fn.drag_drop_selectable.deselectItem($item);
		}
	};
	$.fn.drag_drop_selectable.selectItem = function($item)
	{
		if (!$.fn.drag_drop_selectable.isItemSelected($item))
		{
			$item.trigger('dds.select');
		}
	};
	$.fn.drag_drop_selectable.deselectItem = function($item)
	{
		if ($.fn.drag_drop_selectable.isItemSelected($item))
		{
			$item.trigger('dds.deselect');
		}
	};
	$.fn.drag_drop_selectable.isItemSelected = function($item)
	{
		return $item.hasClass('dds_selected');
	};
	$.fn.drag_drop_selectable.replace = function($item)
	{
		var $list = $.fn.drag_drop_selectable.getListFromItem($item);
		$.fn.drag_drop_selectable.selectNone($list);
		$item.trigger('dds.select');
	};
	$.fn.drag_drop_selectable.selectNone = function($list)
	{
		// Remove all selections from list
		$items = $list.children();
		$items.each(function()
		{
			var $item = $(this);
			$.fn.drag_drop_selectable.deselectItem($item);
		});
		return false;
	};
	$.fn.drag_drop_selectable.selectAll = function($list)
	{
		$items = $list.children();
		$items.each(function()
		{
			$.fn.drag_drop_selectable.selectItem($(this));
		});
		return false;
	}
	$.fn.drag_drop_selectable.selectInvert = function($list)
	{
		$items = $list.children();
		$items.each(function()
		{
			$.fn.drag_drop_selectable.toggle($(this));
		});
		return false;
	};

	$.fn.drag_drop_selectable.getListFromId = function(list_id)
	{
		return $('ul[dds=' + list_id + '] li');
	};
	$.fn.drag_drop_selectable.getListFromItem = function($item)
	{
		return $item.parent('ul');
	};
	$.fn.drag_drop_selectable.getListId = function(item_id)
	{
		return parseInt($('li[dds=' + item_id + ']').parent('ul').eq(0).attr('dds'));
	};

	$.fn.drag_drop_selectable.serializeArray = function($list)
	{

		var out = [];
		$items = $list.children();
		$items.each(function()
		{
			out.push($(this).attr('id'));
		});
		return out;

	};
	$.fn.drag_drop_selectable.serialize = function($list)
	{
		return $.fn.drag_drop_selectable.serializeArray($list).join(", ");
	};

	$.fn.drag_drop_selectable.unique = 0;
	$.fn.drag_drop_selectable.stack = [];
	$.fn.drag_drop_selectable.defaults =
	{
		moveOpacity : 0.8, // opacity of moving items
		ghostClass : 'dds_ghost', // class for "left-behind" item.
		hoverClass : 'dds_hover', // class for acceptable drop targets on hover
		moveClass : 'dds_move', // class to apply to items whilst moving them.
		selectedClass : 'dds_selected' // this default will be aplied any way, but the overridden one too.
	}
	$.fn.drag_drop_selectable.settings = [];

	$.extend(
	{
		dds :
		{
			selectAll : function(id)
			{
				return $.fn.drag_drop_selectable.selectAll($('#' + id));
			},
			selectNone : function(id)
			{
				return $.fn.drag_drop_selectable.selectNone($('#' + id));
			},
			selectInvert : function(id)
			{
				return $.fn.drag_drop_selectable.selectInvert($('#' + id));
			},
			serialize : function(id)
			{
				return $.fn.drag_drop_selectable.serialize($('#' + id));
			}
		}
	});

	// add prm_roflag to designate page read only status
	// add prm_source retuns the filename to check with before the data moved between the sides
	$.fn.drag_drop_selectable.dragdraw=function(label, label_right, feed, feed_right,
		id, column_name, id_right, column_right, div_id, user_access, sorting, prm_roflag, prm_source)
	{
		$(document).ready(function()
		{
			// reset unique identifier to index list items
			$.fn.drag_drop_selectable.unique = 0;
			var random = Math.random() * 99999;
			// set the global variable CheckWith_FileName 
			if (prm_source) 
			{
				CheckWith_FileName = prm_source;
			}
			 
			ReadOnlyFlag = false; // default value
			// check for the page level read only status
			if (prm_roflag == '1')
			{
				ReadOnlyFlag = "true";  
			}

			$('#' + div_id).load('/Utils/dragndrop.html?r=' + random.toString(), function()
			{
				$('.user_access').hide();
				if ((user_access == "user_access") || (user_access == "sort_access"))
				{
					$('#sort_right').css('width', 470);
					$('#sort_plus').css('left', 900);
				}
				else
				{
					$('#sort_right').css('width', 280);
					$('#sort_plus').css('left', 680);
				}

				$('#search_dropdown_right').html(label_right);
				$('#search_dropdown').html(label);
				
				// do not show button for read only access level  && do not attach events 
				if(ReadOnlyFlag == "true" ) 
				{
					$("#sort_plus").hide();
					$('#r_arrow').hide();
					$('#l_arrow').hide();
				} 
				else
				{
					$('#r_arrow').on("click", function(e, ui)
					{
						var total = $('.left').length + 1;
						$('#sort').find('li.dds_selected').each(function()
						{
							var $this = $(this);
							var database_id = $this.attr('class').split(' ')[0];
							var item = $this.attr('dds');
							$.fn.drag_drop_selectable.moveBetweenLists(item, 0, total, database_id);
						});
						updateAddList();
					})

					$('#l_arrow').on("click", function(e,ui)
					{
						var total = $('.left').length + 1;
						$('#sort_right').find('li.dds_selected').each(function()
						{
							var $this = $(this);
							var database_id = $this.attr('class').split(' ')[0];
							var item = $this.attr('dds');
						   $.fn.drag_drop_selectable.moveBetweenLists(item, total, 0, database_id);
						});
						updateAddList();
					})

					if ((sorting == "false") || !sorting)
					{
						$("#sort_plus").hide();
					}
					else
					{
						$("#sort_plus").show();
					}
				}
				if (user_access == "user_access")
				{
					location.hash = "user_access";
				}
				else if (user_access == "sort_access")
				{
					location.hash = "sort_access";
				}

				$('#input_left').on("keyup", function(event)
				{
					// check for valid key pressed to search for
					if ($.fn.isNotValidKeyPressedOnSearchBox(event.keyCode))
					{
						return;	
					}
					// clean up text from special char to avoid errors
					var search_text = DoCleanSearchText($('#input_left').val());
					var rg = new RegExp(search_text, 'i');
					$('#sort li').each(function()
					{
						var $this = $(this);
						// get current item text
						// remove text from 'access' option list 
						var str =  $this.text();                       
						var str_to_replace =  $this.find('.access').text();
						str = str.replace(str_to_replace,'','gi');
						// find serching text within current item's text
   
						if (str.search(rg) == -1)
						{
							$this.hide(); 
						}
						else
						{
							$this.show();							
						}
					});
				});

				$('#input_right').on("keyup", function(event)
				{
					// check for valid key pressed to search for
					if ($.fn.isNotValidKeyPressedOnSearchBox(event.keyCode))
					{
						return;	
					}
					// clean up text from special char to avoid errors
					var search_text = DoCleanSearchText($('#input_right').val());				
					var rg = new RegExp(search_text, 'i');
					$('#sort_right li').each(function()
					{
						var $this = $(this);
						// get current item text
						// remove text from 'access' option list 
						var str =  $this.text();                       
						var str_to_replace =  $this.find('.access').text();
						str = str.replace(str_to_replace,'','gi');
						// find serching text within current item's text
						if (str.search(rg) == -1)
						{
							$this.hide(); 
						}
						else
						{
							$this.show();							
						}
					});
				});

				// user_access is used for User Groups (UG-), Users (U-), and Multi Sort Column (SO-).
				if(user_access == "user_access" || user_access == "sort_access") 
				{
					$.getJSON(feed, function(data) 
					{
						var items = []; 
						$.each(data, function(key, val) 
						{
							keyid=data[key]['Id'];
							// RO- stand for the read only item if found put the roflag attribute to the list item level
							// use GetAccessList(val.AccessFlags) to find related accesss options

							if  (keyid != 'undefined' && keyid.substring(0,3) == "RO-" || ReadOnlyFlag == "true" ) 
							{                       			                        			                       		
								$('#sort').append('<li class="'+eval('val.'+id)+' left sort_list ro_item" RoFlag="1" ><div><div class="li_content"><div class="popuptext '+eval('val.'+id)+'" style="display: none;" >'+ eval('val.'+column_name) +'</div>' + eval('val.'+column_name) + '</div> <div class="user_left" style="display: none;"> '+ GetAccessList(val.AccessFlags)+ '</div></div></li>');
							}
							else if (keyid != 'undefined' && keyid.substring(0,3) == "UG-")
							{
								$('#sort').append('<li class="'+eval('val.'+id)+' left sort_list"><div><div class="li_content"><div class="popuptext '+eval('val.'+id)+'" style="display: none;">'+ eval('val.'+column_name) +'</div>' + eval('val.'+column_name) + '</div>  <div class="user_left" style="display: none;"><select class="access"><option value=2>Read Only</option><option value=6>Full Control</option></select></div></div></li>');   
							}
							else if (keyid != 'undefined' && keyid.substring(0,3) == "SO-")
							{
								$('#sort').append('<li class="'+eval('val.'+id)+' left sort_list"><div><div class="li_content"><div class="popuptext '+eval('val.'+id)+'" style="display: none;">'+ eval('val.'+column_name) +'</div>' + eval('val.'+column_name) + '</div>  <div class="user_left" style="display: none;"><select class="access"><option value="Ascending">Ascending</option><option value="Descending">Descending</option></select></div></div></li>');   
							}  else 
							{
								$('#sort').append('<li class="'+eval('val.'+id)+ ' left sort_list" ><div><div class="li_content"><div class="popuptext '+eval('val.'+id)+'" style="display: none;">'+ eval('val.'+column_name) +'</div>' + eval('val.'+column_name) + '</div>  <div class="user_left" style="display: none;"><select class="access"><option value=1>No Access</option><option value=2>Read Only</option><option value=6>Full Control</option></select></div></div></li>');   
							}
						}); 
						 
						$('.user_left').hide();
						$.getJSON(feed_right, function(data) 
						{                        	
							var items = []; 
							$.each(data, function(key, val) 
							{ 	
								keyid=data[key]['Id'];
								// RO- stand for the read only item if found put the roflag attribute to the list item level
								// use GetAccessList(val.AccessFlags) to find related accesss options
								if  (keyid != 'undefined' && keyid.substring(0,3) == "RO-" || ReadOnlyFlag == "true" ) 
								{                       			                        			
									$('#sort_right').append('<li class="'+eval('val.'+id_right)+ ' right sort_list ro_item" RoFlag="1"><div><div class="li_content"><div class="popuptext '+eval('val.'+id)+'" style="display: none;">'+ eval('val.'+column_name) +'</div>' + eval('val.'+column_right)+ '</div><div class="user_select">'+ GetAccessList(val.AccessFlags)+ '</div></div></li>');                         			    
								
								}                    			
								else if (keyid != 'undefined' && keyid.substring(0,3) == "UG-")
								{
									$('#sort_right').append('<li class="'+eval('val.'+id_right)+' right sort_list"><div><div class="li_content"><div class="popuptext '+eval('val.'+id)+'" style="display: none;">'+ eval('val.'+column_name) +'</div>' + eval('val.'+column_right)+ '</div><div class="user_select"><select class="access"><option value=2>Read Only</option><option value=6>Full Control</option></select></div></div></li>'); 
								} 
								else if (keyid != 'undefined' && keyid.substring(0,3) == "SO-")
								{
									$('#sort_right').append('<li class="'+eval('val.'+id_right)+' right sort_list"><div><div class="li_content"><div class="popuptext '+eval('val.'+id)+'" style="display: none;">'+ eval('val.'+column_name) +'</div>' + eval('val.'+column_right)+ '</div><div class="user_select"><select class="access"><option value="Ascending">Ascending</option><option value="Descending">Descending</option></select></div></div></li>'); 
								}
								 else 
								{  
									$('#sort_right').append('<li class="'+eval('val.'+id_right)+' right sort_list"><div><div class="li_content"><div class="popuptext '+eval('val.'+id)+'" style="display: none;">'+ eval('val.'+column_name) +'</div>' + eval('val.'+column_right)+ '</div><div class="user_select"><select class="access"><option value=1>No Access</option><option value=2>Read Only</option><option value=6>Full Control</option></select></div></div></li>'); 
								}     
								$("#sort_right li:last select").val(val.AccessFlags);                            	
							
							}                            
							);
							 
							mychange = function ( $list )
							{
								$( '#'+$list.attr('id')+'_serialised').html( $.dds.serialize( $list.attr('id')) );
							}
					
							$('ul#sort, ul#sort_right').drag_drop_selectable(
							{
								onListChange:mychange
							});
					
							$('#list_1_serialised').html($.dds.serialize('list_1'));
							$('#list_2_serialised').html($.dds.serialize('list_2')); 
		 
						}); 
					});

					$("body").on("change", 'select.access', function() 
					{
						updateAddList();
					});
				}

						
				if (user_access == "no_access" ||  user_access == "" || user_access === undefined) 
				{
					$.getJSON(feed, function(data) 
					{
						var items = [];                     
						$.each(data, function(key, val) 
						{
								var keyid=data[key]['Id'];
								var RoFlag = 0;
								var RoStyle ='';
								var RoKey = 0;
								// RO- stand for the read only item if found put the roflag attribute to the list item level  
								if  (keyid)
								{
									if( keyid.substring(0,3) == "RO-"  )
									{
										RoKey=1;
									}
								}
									
								if( RoKey == 1 || ReadOnlyFlag == "true" )
								{
									RoFlag=1;
									RoStyle = ' ro_item';
								} 
							$('#sort').append('<li class="'+eval('val.'+id)+' left sort_list '+ RoStyle + '" RoFlag="'+RoFlag+'"><div class="li_content"><div class="'+eval('val.'+id)+'"></div><div class="popuptext '+eval('val.'+id)+'" style="display: none;">'+ eval('val.'+column_name) +'</div>' +eval('val.'+column_name)+ '<div></li>');    
						
						}); 
 
						$.getJSON(feed_right, function(data) 
						{
							var items = []; 
							$.each(data, function(key, val) 
							{
								var keyid=data[key]['Id'];
								var RoFlag = 0;
								var RoStyle ='';
								var RoKey = 0;
								// RO- stand for the read only item if found put the roflag attribute to the list item level  
								if  (keyid)
								{
									if( keyid.substring(0,3) == "RO-"  )
									{
										RoKey=1;
									}
								}
									
								if( RoKey == 1 || ReadOnlyFlag == "true" )
								{
									RoFlag=1;
									RoStyle = ' ro_item';
								} 

								$('#sort_right').append('<li class="'+eval('val.'+id_right)+' right sort_list  '+ RoStyle + '" RoFlag="'+RoFlag+'"><div class="li_content"><div class="'+eval('val.'+id_right)+'"></div><div class="popuptext '+eval('val.'+id_right)+'" style="display: none;">'+ eval('val.'+column_name) +'</div><div style="float:left; width:220px;word-break: keep-all">'+eval('val.'+column_right)+'</div></li>'); 
							});

							mychange = function ( $list )
							{
								$( '#'+$list.attr('id')+'_serialised').html( $.dds.serialize( $list.attr('id')) );
							}

							$('ul#sort, ul#sort_right').drag_drop_selectable(
							{
								onListChange:mychange
							});

							$( '#list_1_serialised').html( $.dds.serialize( 'list_1' )  );
							$( '#list_2_serialised').html( $.dds.serialize( 'list_2' )  );     
						}); 
					});
				}
			}); // .load
		});
	}
	
// converts RegExp special char to text
function DoCleanSearchText( str)
{
	if (str.trim().length>-1) 
	{
		str = str
		.replace(/\]/g,'[/]/]')
		.replace(/\[/g,'[/[/]')
		.replace(/\(/g,'[(]') 
		.replace(/\)/g,'[)]')				
		.replace( /\*/g,'[*]') 
		.replace(/\|/g,'[|]')
		.replace(/\?/g,'[?]')
		.replace(/\^/g,'[^]')   
		.replace(/\\/g, '[/\\/]')
		.replace( /\+/g,'[+]') ;
	}
	return (str);
}
// based on RoFlag returns access value
function GetAccessList(RoValId)
{  	var accessArr = ['','No Access','Read Only','Ascending','Descending','','Full Control'];
	 if (RoValId == 'Ascending' || RoValId == 'Descending' ) 
	 {
		 return  RoValId ;
	 }

	 if (RoValId != 'undefined')
	 {
		return (accessArr[RoValId]+'');	    // read only 
	 }
	 return '';	    
 } 
 
// checks to see if its ok to move specific items between sides 
// param Id  - database id for the item to move
// param Action  - flag for 1=assigning or 0=unassigning
function DoSendRequest_ToMove (Id, Action, Parms)
{
	if (CheckWith_FileName == '')
	{
		// No operation checker, proceed with move
		MoveItem(true, Parms);
		return;
	}

	// read datat from both sides     
	var RightListData =  GetListData('sort_right');
	var LeftListData = GetListData('sort');

	$.ajax(
	{
		type : "post",
		url : '/' + CheckWith_FileName  +'?ItemId=' + Id+'&Action='+Action,
		data : 'RightListData=' + RightListData +'&LeftListData=' + LeftListData,
	})
	.done (function(Response, testStatus, jqXHR)
	{
		var Status = CheckResults(Response);
		MoveItem(Status, Parms);
	})
	.fail (function(jqXHR, textStatus, errorThrown)
	{
		DisplayAjaxError(errorThrown, textStatus, '');
	});
}

function CheckResults(Response)
{
	var responseCode = Response.replace(/\r\n/g, "");  
	if (responseCode.indexOf("false:") > -1)
	{	
		alert (responseCode.substring(responseCode.indexOf(":")+1));			
		return false;
	}
	if (responseCode == "true")
	{
		return true;
	}
	// check if user needs to confirm the action
	else if (responseCode.indexOf("confirm:") > -1)
	{
		// confirm with recieved message   
		msg = responseCode.substring(responseCode.indexOf(":")+1) ; 
		msg =  msg.replace(/<br \/>/g, "\n"); 
		if (confirm(msg))
		{
			return true;
		}
		else
		{
			return false;
		}
	}
}

  // Checks to see if in Healthcare -Admin/ Admin Settings section
  // Will update 'Admin Settings' tab to show in modified style - in dark blue color
  // This has to be called everytime items are moved between the lists or sorted
  function UpdateHealthCareTab() 
  {
	  if ($('#PALModuleDiv').length>0)	
	  {
		  if ($('[aria-selected="true"]').length>0 )
		  {
			  if ($('[aria-selected="true"]').children().text() ==  'Admin Settings' )
			  {
				  // check to see if there are items to be assigned or unassigned
				  // if not then remove the modified tab class
				  if ( $('#sort_right .left').length == 0 && $('#sort .right').length == 0 )
				  {
					 if ($('[aria-selected="true"]').children().hasClass('ModifiedTab') == true)
					  { 
						  $('[aria-selected="true"]').children().removeClass('ModifiedTab');
					  }
				  }
				  else
				  {
					  if ($('[aria-selected="true"]').children().hasClass('ModifiedTab') == false)
					  {
						 $('[aria-selected="true"]').children().attr('class','ModifiedTab');				  
					  }
				  }			  	  
			  }
		  }		
	  }  
  }
  
	var CTRL_KEY = 17;
	var ALT_KEY = 18;
	var SHIFT_KEY = 16;
	var META_KEY = 92;
	$.fn.captureKeys = function()
	{

		if ($.fn.captureKeys.capturing)
		{
			return;
		}
		$(document).on("keydown", function(e)
		{
			if (e.keyCode == CTRL_KEY)
			{
				$.fn.captureKeys.stack.CTRL_KEY = true
			}
			if (e.keyCode == SHIFT_KEY)
			{
				$.fn.captureKeys.stack.SHIFT_KEY = true
			}
			if (e.keyCode == ALT_KEY)
			{
				$.fn.captureKeys.stack.ALT_KEY = true
			}
			if (e.keyCode == META_KEY)
			{
				$.fn.captureKeys.stack.META_KEY = true
			}
		}).on("keyup", function(e)
		{
			if (e.keyCode == CTRL_KEY)
			{
				$.fn.captureKeys.stack.CTRL_KEY = false
			}
			if (e.keyCode == SHIFT_KEY)
			{
				$.fn.captureKeys.stack.SHIFT_KEY = false
			}
			if (e.keyCode == ALT_KEY)
			{
				$.fn.captureKeys.stack.ALT_KEY = false
			}
			if (e.keyCode == META_KEY)
			{
				$.fn.captureKeys.stack.META_KEY = false
			}
		});
	};
	$.fn.captureKeys.stack =
	{
		CTRL_KEY : false,
		SHIFT_KEY : false,
		ALT_KEY : false,
		META_KEY : false
	}
	$.fn.captureKeys.capturing = false;
	$.fn.isPressed = function(key)
	{
		switch (key)
		{
			case CTRL_KEY :
				return $.fn.captureKeys.stack.CTRL_KEY;
			case ALT_KEY :
				return $.fn.captureKeys.stack.ALT_KEY;
			case SHIFT_KEY :
				return $.fn.captureKeys.stack.SHIFT_KEY;
			case META_KEY :
				return $.fn.captureKeys.stack.META_KEY;
			default :
				return false;
		}
	}
	// For Left and Right search boxes need to capture key pressed 
	// Returns true if the KeyCode pressed is not vaid to make a search for, the following are invalid keys :
	/* tab 9, enter 13, shift 16, ctrl 17, alt 18, pause/break 19, caps lock 20, escape 27, page up 33,
	 page down 34, end 35, home 36, left arrow 37, up arrow 38, right arrow 39, down arrow 40, 
	 insert 45 , left window key 91, right window key 92, select key 93 , f1 112, f2 113, f3 114,
	 f4 115, f5 116, f6 117, f7 118, f8 119, f9 120, f10 121, f11 122, f12 123, num lock 144, scroll lock 145*/ 
	$.fn.isNotValidKeyPressedOnSearchBox = function(key)
	{
		if ( ((key >= 9 && key <= 45 ) || (key >= 91 && key <= 93) || (key >= 112 && key <= 145 )) && (key != 32))		
		{
			return true;
		}
		return false;
	}
	
})(jQuery);


(function($) {
	if ($.browser.mozilla) {
		$.fn.disableTextSelect = function() {
			return this.each(function() {
				$(this).css({
					'MozUserSelect' : 'none'
				});
			});
		};

	} else if ($.browser.msie) {
		$.fn.disableTextSelect = function() {
			return this.each(function() {
				$(this).on('selectstart.disableTextSelect', function() {
					return false;
				});
			});
	};    

	} else {
		$.fn.disableTextSelect = function() {
			return this.each(function() {
				$(this).on('mousedown.disableTextSelect', function() {
					return false;
				});
			});
		};

	}
})(jQuery);
